import { render, staticRenderFns } from "./MessageWrapper.vue?vue&type=template&id=7ec48ae4&scoped=true&"
import script from "./MessageWrapper.vue?vue&type=script&lang=js&"
export * from "./MessageWrapper.vue?vue&type=script&lang=js&"
import style0 from "./MessageWrapper.vue?vue&type=style&index=0&id=7ec48ae4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ec48ae4",
  null
  
)

export default component.exports